<template>
    <div class="pricing-box xl:text-left lg:text-left text-left md:text-center text-white px-spc50 flex-1 w-full">
        <h1 class="price inline-block leading-spc2 text-size6 relative mb-spc47">
            <span class="currency text-size1">$</span>
            <span v-if="pricingProps.price">{{pricingProps.price}}</span>
            <span v-if="pricingProps.offer" class="ribbon bg-darkyellow absolute block top-0 px-spc36 py-1 text-darken font-opensans font-semibold leading-spc8 text-xs uppercase">
                {{pricingProps.offer}}
            </span>
        </h1>
        <h3 v-if="pricingProps.title" class="title block text-2xl font-medium mb-spc48">
            {{pricingProps.title}}
        </h3>
        <p v-if="pricingProps.content" class="text-base opacity-50 leading-6 mb-spc49 w-full max-w-300px xl:ml-0 xl:mr-0 lg:ml-0 lg:mr-0 md:ml-auto md:mr-auto">
            {{pricingProps.content}}
        </p>
        <ul class="feature-lists pt-spc3" v-if="pricingProps.features">
            <li class="text-base opacity-50 leading-6 mb-spc51" v-for="(item, i) in pricingProps.features" :key="i">
                {{item.title}}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "PricingBox",
        props: ['pricingProps']
    }
</script>

<style scoped>

</style>